import { APP_READY } from './actionTypes';

/**
 * @description App was ready
 * @returns {Object} new State
 */
export const AppReady = () => ({
  type: APP_READY,
});
